var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Auth } from "aws-amplify";
import config from "../../../assests/config";
import apiService from "../../../helpers/apiService";
import { getIdCardDetails, getOriginalEmailId } from "../api";
import { errorHandler } from "../api/handlers";
import { storeAuthUserDetails } from "../handlers";
const forgotPasswordScenarios = {
    CONFIRMED: "CONFIRMED",
    FORCE_CHANGE_PASSWORD: "FORCE_CHANGE_PASSWORD", // Navigate to Reset passoword page
};
const checkRegistrationScenarios = {
    CONFIRMED: "CONFIRMED",
    FORCE_CHANGE_PASSWORD: "FORCE_CHANGE_PASSWORD", // Navigate to Reset passoword page
};
export const forgotPasswordHandler = (data) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let validEmailId = data.userInfo.email;
        if (data.UI !== config.UI.agency) {
            validEmailId = yield getOriginalEmailId({
                sessionURL: data.appConfig.sessionURL,
                email: data.userInfo.email,
                brand: data.appConfig.brand,
            });
        }
        return yield getUserDetails({
            validEmailId,
            awsConfig: data.awsConfig,
            appConfig: data.appConfig,
            UI: data.UI
        });
    }
    catch (error) {
        const message = errorHandler(error, config.errorMessages.SOMETHING_WRONG);
        return Promise.reject({
            dialog: "noActiveAccount",
            message,
        });
    }
});
export const getUserDetailsForgotAgency = ({ validEmailId, }) => __awaiter(void 0, void 0, void 0, function* () {
    let forgotPasswordResult = {
        isVerificationSent: false,
        codeToEmail: null,
        dialog: "",
        nextAuth: "",
        email: validEmailId,
    };
    try {
        const confirmedResponse = yield AuthForgotPassword({ validEmailId });
        forgotPasswordResult = Object.assign(Object.assign(Object.assign({}, forgotPasswordResult), confirmedResponse), { nextAuth: ForgotPassNextSteps(Object.assign({}, confirmedResponse)) });
        return Promise.resolve(forgotPasswordResult);
    }
    catch (error) {
        return Promise.reject(Object.assign(Object.assign({}, forgotPasswordResult), { message: errorHandler(error, config.errorMessages.TRY_AGAIN) }));
    }
});
export const getUserDetails = ({ awsConfig, validEmailId, appConfig, UI }) => __awaiter(void 0, void 0, void 0, function* () {
    let forgotPasswordResult = {
        isVerificationSent: false,
        codeToEmail: null,
        dialog: "",
        nextAuth: "",
        email: validEmailId,
    };
    try {
        const createRequestURL = appConfig.sessionURL + config.API_URLS.getUser;
        const getUserRequest = {
            cognitoUserPool: awsConfig.aws_user_pools_id,
            username: validEmailId,
        };
        let getUserApiResponse = { userStatus: forgotPasswordScenarios.CONFIRMED };
        if (UI !== config.UI.agency) {
            const { data: userApiResponse } = (yield apiService.post({
                URL: createRequestURL,
                brand: appConfig.brand,
                data: getUserRequest,
            })) || {};
            getUserApiResponse = userApiResponse;
        }
        if (!getUserApiResponse)
            return Promise.reject({
                message: config.errorMessages.SOMETHING_WRONG,
                dialog: "noActiveAccount",
            });
        let { userStatus } = getUserApiResponse || {};
        if (userStatus === forgotPasswordScenarios.CONFIRMED) {
            const confirmedResponse = yield AuthForgotPassword({ validEmailId });
            forgotPasswordResult = Object.assign(Object.assign(Object.assign({}, forgotPasswordResult), confirmedResponse), { nextAuth: ForgotPassNextSteps(Object.assign({}, confirmedResponse)) });
        }
        else if (userStatus === forgotPasswordScenarios.FORCE_CHANGE_PASSWORD) {
            const resetPassword = yield ResetPassword({
                awsConfig,
                validEmailId,
                appConfig,
            });
            forgotPasswordResult = Object.assign(Object.assign({}, forgotPasswordResult), resetPassword);
        }
        else {
            forgotPasswordResult = Object.assign(Object.assign({}, forgotPasswordResult), { dialog: "forcedPassword" });
        }
        return Promise.resolve(forgotPasswordResult);
    }
    catch (error) {
        return Promise.reject(Object.assign(Object.assign({}, forgotPasswordResult), { message: errorHandler(error, config.errorMessages.TRY_AGAIN) }));
    }
});
export const AuthForgotPassword = ({ validEmailId }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { CodeDeliveryDetails } = yield Auth.forgotPassword(validEmailId);
        return Promise.resolve({
            isVerificationSent: true,
            codeToEmail: CodeDeliveryDetails.Destination,
        });
    }
    catch (error) {
        return Promise.reject({
            isVerificationSent: false,
            codeToEmail: null,
            message: errorHandler(error, config.errorMessages.TRY_AGAIN),
        });
    }
});
// Used in 2 functions
export const ResetPassword = ({ appConfig, awsConfig, validEmailId, email, }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const getUserRequest = {
            cognitoUserPool: awsConfig.aws_user_pools_id,
            username: email || validEmailId,
        };
        const resetRequest = {
            URL: appConfig.sessionURL + config.API_URLS.resetuser,
            brand: appConfig.brand,
            data: getUserRequest,
        };
        yield apiService.post(resetRequest);
        return Promise.resolve({ dialog: "forcedPassword" });
    }
    catch (error) {
        return Promise.reject({
            dialog: "",
            message: errorHandler(error, config.errorMessages.TRY_AGAIN),
        });
    }
});
export const ForgotPassNextSteps = ({ isVerificationSent }) => {
    return isVerificationSent ? "CPWC" : "RP";
};
export const checkRegistrationHander = ({ appConfig, awsConfig, userInfo, }) => __awaiter(void 0, void 0, void 0, function* () {
    let response = {
        dialog: "notFound",
    };
    try {
        const validEmailId = yield getOriginalEmailId({
            sessionURL: appConfig.sessionURL,
            email: userInfo.email,
            brand: appConfig.brand,
        });
        const createRequestURL = appConfig.sessionURL + config.API_URLS.getUser;
        const getUserRequest = {
            cognitoUserPool: awsConfig.aws_user_pools_id,
            username: validEmailId,
        };
        const { data: getUserApiResponse } = (yield apiService.post({
            URL: createRequestURL,
            brand: appConfig.brand,
            data: getUserRequest,
        })) || {};
        if (!getUserApiResponse)
            return Promise.reject({ message: config.errorMessages.SOMETHING_WRONG });
        let { userStatus } = getUserApiResponse || {};
        if (userStatus === checkRegistrationScenarios.CONFIRMED) {
            response = Object.assign(Object.assign({}, response), { dialog: "Confirmed" });
        }
        else if (userStatus === checkRegistrationScenarios.FORCE_CHANGE_PASSWORD) {
            yield ResetPassword({ appConfig, awsConfig, validEmailId });
            response = Object.assign(Object.assign({}, response), { dialog: "forcedPassword" });
        }
        else {
            response = Object.assign(Object.assign({}, response), { dialog: "notFound" });
        }
        return Promise.resolve(response);
    }
    catch (error) {
        return Promise.reject(Object.assign({ message: errorHandler(error, config.errorMessages.TRY_AGAIN) }, response));
    }
});
export const conifrmationSignIn = ({ userInfo, appConfig, }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { code, email, authenticatedUser } = userInfo;
        let userDetails;
        if (userInfo.ui !== "agency") {
            userDetails = yield getIdCardDetails({
                sessionURL: appConfig.sessionURL,
                email,
                brand: appConfig.brand,
            });
            if (!userDetails)
                return Promise.reject({ message: config.errorMessages.INCORRECT_USER });
        }
        yield Auth.confirmSignIn(authenticatedUser.authenticatedUser.authUserInfo, code, "SMS_MFA");
        let authUserInfo = authenticatedUser.authenticatedUser.authUserInfo;
        if (userInfo.ui !== "agency")
            storeAuthUserDetails({ userDetails, authUserInfo });
        return Promise.resolve({
            authUserInfo: authUserInfo.attributes,
            isAuthenticated: true, // saved all user realted info in storage
        });
    }
    catch (error) {
        return Promise.reject({
            message: errorHandler(error, config.errorMessages.SOMETHING_WRONG),
            isAuthenticated: false,
        });
    }
});
export const modifyDialogContent = ({ dialog, dialogContent, values, props, }) => {
    var _a, _b, _c;
    if (dialog === "notFound") {
        dialogContent.title = `${dialogContent.title} ${values.email}`;
        dialogContent.content =
            dialogContent.content +
                (((_a = props.appConfig) === null || _a === void 0 ? void 0 : _a.brand) === config.netwell
                    ? "1(866) 638-9355"
                    : ((_b = props.appConfig) === null || _b === void 0 ? void 0 : _b.brand) === config.innovation
                        ? "866-949-3581"
                        : ((_c = props.appConfig) === null || _c === void 0 ? void 0 : _c.brand) === config.ipaec ?
                            "866-949-3581"
                            : "(888) 308 0024");
    }
    if (dialog === "noActiveAccount") {
        dialogContent.title = `${dialogContent.content} ${values.email}`;
    }
    return dialogContent;
};
